<template>
  <a-modal
    title="创建项目"
    :width="700"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel">
    <a-form :form="form">
      <a-form-item label="项目名称" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 17 }">
        <a-input v-decorator="['name', { rules: [{ required: true, message: '请输入项目名称' }] }]" placeholder="请输入"/>
      </a-form-item>
      <a-form-item label="项目地址" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 17 }">
        <a-cascader
          placeholder="请选择省/市/区"
          :options="areaOptions"
          v-decorator="['province', {
            rules: [{ required: true, message: '请选择项目地址' }],
            initialValue: []
          }]"
        />
      </a-form-item>
      <a-form-item label=" " :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 17 }" :colon="false" >
        <a-input
          placeholder="请输入详细地址"
          v-decorator="['address', {
            rules: [{ required: false, message: '请输入详细地址' }]
          }]"
        />
      </a-form-item>
      <a-form-item label="授权数量" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 17 }">
        <a-input-number v-decorator="['max', { rules: [{ required: true, message: '请输入授权数量' }] }]" style="width: 200px" placeholder="请输入" :min="1"/>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { createProjectFirstItem, updateProjectFirstItem } from '@/api/projectItem'
import { areaOptions, getAreaName } from '@/utils/area'
export default {
  name: 'ProjectModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      confirmLoading: false,
      project: null,
      areaOptions: areaOptions
    }
  },
  methods: {
    load (project) {
      this.project = project
      this.form.setFieldsValue({
        name: project.name,
        address: project.address,
        province: project.province.split('/'),
        max: project.max || 0
      })
    },
    handleOk () {
      this.confirmLoading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          setTimeout(() => {
            values.province = values.province.join('/')
            values.provinceCH = getAreaName(values.province)
            values.address = values.address || ''
            if (this.project) {
              values.id = this.project.id
              updateProjectFirstItem(values).then(res => {
                if (res.code === 1) {
                  this.$message.success('项目更新成功')
                  this.$emit('ok', values)
                  this.confirmLoading = false
                  this.handleCancel()
                }
              })
            } else {
              createProjectFirstItem(values).then(res => {
                if (res.code === 1) {
                  this.$message.success('项目创建成功')
                  this.$emit('ok', values)
                  this.confirmLoading = false
                  this.handleCancel()
                }
              })
            }
            this.confirmLoading = false
            this.handleCancel()
          }, 500)
        } else {
          this.confirmLoading = false
        }
      })
    },
    handleCancel () {
      this.form.resetFields()
      this.project = null
      this.$emit('update:visible', false)
    }
  }
}
</script>
